import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

// Create-or-get for the collection's edition bundle. The API is idempotent:
// with the creator kind the collection already has, it returns the existing
// bundle's url without creating anything — which is how the dialog fetches
// the url for the Copy button.
const useEditionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["collection-edition"],
    mutationFn: ({
      collectionId,
      creator,
    }: {
      collectionId: string;
      creator: "artist" | "backoffice";
    }) => {
      return collectionApiClient.createEdition(collectionId, creator);
    },
    onSettled: (_data, _error, { collectionId }) =>
      Promise.all([
        queryClient.refetchQueries({ queryKey: ["collections"] }),
        queryClient.refetchQueries({ queryKey: ["collection", collectionId] }),
      ]),
  });
};

export default useEditionMutation;
